<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container" style="padding-top:50px;">
        <div class="columns is-centered">
          <div class="column is-one-third">
            <app-alert @dismissed="closeError" v-if="error" :text="errorMsg"></app-alert>

            <div class="box">
              <form @submit.prevent="login">
                <div class="field">
                  <div class="control">
                    <input
                      class="input is-large"
                      v-model="userData.email"
                      type="email"
                      placeholder="E-Mail"
                      autofocus
                    >
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      class="input is-large"
                      v-model="userData.password"
                      type="password"
                      placeholder="Passwort"
                    >
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <button
                      class="button is-fullwidth is-primary is-large"
                      :disabled="loading"
                      :loading="loading"
                      :class="{ 'is-loading' : loading }"
                    >Login</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import axios from 'axios'
export default {
  data() {
    return {
      userData: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    login() {
      this.$store.commit('setLoading', true)
      this.$store.commit('clearError')
      axios.get('/sanctum/csrf-cookie').then(response => {
        axios
          .post('/auth/login', this.userData)
          .then(res => {
            // const now = new Date()
            // token expires after 3 hours
            // const expirationDate = new Date(now.getTime() + 180 * 60000)
            // localStorage.setItem('token', res.data)
            // localStorage.setItem('expirationDate', expirationDate)
            // axios.defaults.headers.common['Authorization'] =
            //   'Bearer ' + localStorage.getItem('token')
            this.$store.commit('LOGIN_USER')
            this.$store.commit('setLoading', false)
            this.$router.push('/')
          })
          .catch(() => {
            this.$store.commit('setLoading', false)
            this.$store.commit(
              'setErrorMsg',
              'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.'
            )
          })
      })
    },
    closeError() {
      this.$store.commit('clearError')
    }
  },
  metaInfo: {
    title: 'Login',
    meta: [{ name: 'robots', content: 'NOINDEX, NOFOLLOW' }]
  },
  computed: {
    error() {
      return this.$store.getters.error
    },
    errorMsg() {
      return this.$store.getters.errorMsg
    },
    loading() {
      return this.$store.getters.loading
    }
  }
}
</script>

<style>
</style>
